const Component = () => {
  return <>Cohort Preview</>;
};

export default Component;
